import React from 'react';
import AdminInboxPanel from '../AdminInboxPanel';

const InboxTab = ({ user, socket, language, t }) => {
  return (
    <AdminInboxPanel 
      user={user}
      socket={socket}
      language={language}
      t={t}
    />
  );
};

export default InboxTab;